import { render } from "./ComponentUsers.vue?vue&type=template&id=80f55ffc&scoped=true"
import script from "./ComponentUsers.vue?vue&type=script&lang=js"
export * from "./ComponentUsers.vue?vue&type=script&lang=js"

import "./ComponentUsers.vue?vue&type=style&index=0&id=80f55ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f55ffc"]])

export default __exports__